import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-receipt-cutoff" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "small-fs-1" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-all" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_16 = { class: "setting-data" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_19 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_23 = { class: "d-block my-3" }
const _hoisted_24 = { class: "d-none d-md-block" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "7" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-fill" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_40 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick", "title"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-fill" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_48 = { style: {"padding":"5px 0"} }
const _hoisted_49 = { class: "bold" }
const _hoisted_50 = { style: {"padding":"5px 0"} }
const _hoisted_51 = { class: "bold" }
const _hoisted_52 = { style: {"padding":"5px 0"} }
const _hoisted_53 = { class: "bold" }
const _hoisted_54 = { style: {"padding":"5px 0"} }
const _hoisted_55 = { class: "bold" }
const _hoisted_56 = { style: {"padding":"5px 0"} }
const _hoisted_57 = { class: "bold" }
const _hoisted_58 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_60 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-fill" }, null, -1)
const _hoisted_66 = { class: "d-none t-d-md-table-cell" }
const _hoisted_67 = { class: "d-none t-d-md-table-cell" }
const _hoisted_68 = { class: "d-none t-d-md-table-cell" }
const _hoisted_69 = { class: "d-none t-d-md-table-cell" }
const _hoisted_70 = { class: "d-none t-d-md-table-cell" }
const _hoisted_71 = { class: "d-none t-d-md-table-cell" }
const _hoisted_72 = { class: "sett-small-menu align-right" }
const _hoisted_73 = { class: "discl-menu dropdown" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_75 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { key: 1 }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-fill" }, null, -1)
const _hoisted_84 = { class: "col-md-6 col-sm-12" }
const _hoisted_85 = { class: "area-info" }
const _hoisted_86 = { class: "col-md-6 col-sm-12" }
const _hoisted_87 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_stock_sit_po_detail = _resolveComponent("stock-sit-po-detail")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_PurchaseOrderDetailModal = _resolveComponent("PurchaseOrderDetailModal")!
  const _component_StockEntryModal = _resolveComponent("StockEntryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.purchase_order_dets), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.itemsSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_9, [
              (!_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : _createCommentVNode("", true),
              (_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createVNode(_component_RouterLink, { to: "/app/products/purchases/list" }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode("  " + _toDisplayString(_ctx.language.po) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.relatedPurchase.record.PurchaseOrderNbr), 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.language.supplier) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getSupplierName), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    (_ctx.relatedPurchase.record.OperationStatus == 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:;",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmPOrderOps(_ctx.relatedPurchase.record.PurchaseKey)))
                        }, [
                          _hoisted_14,
                          _createTextVNode("  " + _toDisplayString(_ctx.language.confirm), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.purchase_order_dets_msg), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.language.order_dets), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddEditDetailAction(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstOfPurchaseOrderDetails.length == 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printPurchaseOrder()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_20),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.order_dets), 1)
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.sku), 1)
                  ]),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.type), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.prod_variant), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.qty), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.total_amt), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.stock_info), 1),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstOfPurchaseOrderDetails.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (recProduct) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recProduct.IdPurchaseDetail
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddEditDetailAction(1, recProduct))
                        }, _toDisplayString(_ctx.getSku(recProduct)), 9, _hoisted_35),
                        _createTextVNode("  "),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.entryStockOperation(recProduct)),
                          title: _ctx.language.stock_entry
                        }, _hoisted_38, 8, _hoisted_36),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          to: `/app/products/products/editor/${recProduct.ProductSku}`,
                          title: _ctx.language.view_product_detail
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 2
                        }, 1032, ["to", "title"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.sku) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddEditDetailAction(1, recProduct))
                          }, _toDisplayString(_ctx.getSku(recProduct)), 9, _hoisted_43),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.entryStockOperation(recProduct)),
                            title: _ctx.language.stock_entry
                          }, _hoisted_46, 8, _hoisted_44),
                          _createTextVNode("  "),
                          _createVNode(_component_RouterLink, {
                            to: `/app/products/products/editor/${recProduct.ProductSku}`,
                            title: _ctx.language.view_product_detail
                          }, {
                            default: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 2
                          }, 1032, ["to", "title"])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.language.type) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(_ctx.getType(recProduct)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.language.prod_variant) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(_ctx.getProd(recProduct)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.language.qty) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Qty)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.language.total_amt) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(`${_ctx.currCode}
                    ${_ctx.appFxs.formatNumbers(recProduct.TotalPrice)}`), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.language.stock_info) + ": ", 1),
                          _createTextVNode("  "),
                          _createVNode(_component_stock_sit_po_detail, { purchaseDetail: recProduct }, null, 8, ["purchaseDetail"])
                        ]),
                        _createElementVNode("span", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddEditDetailAction(1, recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_61),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteDetailAction(recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_62),
                            _hoisted_63,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.entryStockOperation(recProduct))
                            }, [
                              _hoisted_65,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.stock_entry), 1)
                            ], 8, _hoisted_64)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.getType(recProduct)), 1),
                    _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.getProd(recProduct)), 1),
                    _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Qty)), 1),
                    _createElementVNode("td", _hoisted_69, _toDisplayString(`${_ctx.currCode} ${_ctx.appFxs.formatNumbers(recProduct.TotalPrice)}`), 1),
                    _createElementVNode("td", _hoisted_70, [
                      _createVNode(_component_stock_sit_po_detail, { purchaseDetail: recProduct }, null, 8, ["purchaseDetail"])
                    ]),
                    _createElementVNode("td", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("span", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("ul", _hoisted_75, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.showAddEditDetailAction(1, recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_76)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deleteDetailAction(recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_77)
                            ]),
                            (_ctx.onePurchaseOper.OperationStatus != 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_78, _hoisted_80))
                              : _createCommentVNode("", true),
                            (_ctx.onePurchaseOper.OperationStatus != 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.entryStockOperation(recProduct))
                                  }, [
                                    _hoisted_83,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.stock_entry), 1)
                                  ], 8, _hoisted_82)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstOfPurchaseOrderDetails.length==0}])
            }, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstOfPurchaseOrderDetails.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("nav", _hoisted_87, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredOperationDet,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_PurchaseOrderDetailModal, {
        visible: _ctx.isPODetailVis,
        initialValues: _ctx.detailInitialValue,
        recordStatus: _ctx.detailRecordStatus,
        purchaseRecord: _ctx.onePurchaseOper,
        listProducts: _ctx.listOfProducts,
        listVariants: _ctx.lstOfProdVariantValues,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "purchaseRecord", "listProducts", "listVariants", "onCloseForm"]),
      _createVNode(_component_StockEntryModal, {
        visible: _ctx.isStockVis,
        initialValues: _ctx.stockEntryRec,
        recordStatus: _ctx.stockEntryStatus,
        purchDetailInfo: _ctx.purchDetailInfo,
        purchaseDetailRecord: _ctx.purchaseDetailRecord,
        productRecord: _ctx.productRecord,
        variantValRecord: _ctx.variantDetailRecord,
        productType: _ctx.productType,
        onCloseForm: _ctx.onStockDlgClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "purchDetailInfo", "purchaseDetailRecord", "productRecord", "variantValRecord", "productType", "onCloseForm"])
    ]))
  ], 64))
}